import classNames from 'classnames';
import React from 'react';

/** Ширины табов комплектов: «Домашняя», «Гостевая», «Третья», «Вратарская». */
const KIT_TAB_WIDTHS = [163, 175, 161, 193];

/** Ширины подписей элементов: «Футболка», «Шорты», «Гетры». */
const ELEMENT_LABEL_WIDTHS = [72, 52, 48];

/** Поле цвета шире своего `basis-36`: его ширину задаёт содержимое (свотч + hex). */
const COLOR_FIELD_WIDTH = 245;

/**
 * Заглушка вкладки «Форма команды» на время загрузки.
 *
 * Повторяет раскладку `KitEditorForm`: ряд табов комплектов, сетка
 * `grid-cols-12` с полями слева и превью справа, пара кнопок внизу. Все размеры
 * сняты с реальной формы в браузере — таб и поле высотой 36px, подпись поля 21px
 * с отступом `mb-2`, превью 220×327. Поэтому при появлении данных содержимое не
 * сдвигается ни по вертикали, ни по горизонтали.
 *
 * Блоков три (футболка, шорты, гетры): до ответа сервера набор элементов вида
 * спорта неизвестен, а этот — самый частый.
 */
export const KitEditorSkeleton: React.FC = () => (
  <div className="flex w-full flex-col gap-6" data-testid="kit-editor-skeleton">
    <div className="flex flex-row items-center gap-4">
      {KIT_TAB_WIDTHS.map((width) => (
        <div key={width} className="skeleton-block h-9" style={{ width }} />
      ))}
    </div>

    <div className="grid grid-cols-12 gap-6">
      <div className="col-span-7 flex flex-col gap-6">
        {ELEMENT_LABEL_WIDTHS.map((labelWidth) => (
          <div key={labelWidth} className="flex flex-col gap-2">
            {/* Подпись элемента: `UDText type="subhead"`, высота 20px. */}
            <div className="skeleton-block h-5" style={{ width: labelWidth }} />

            <div className="flex flex-row flex-nowrap items-start gap-4">
              <FieldSkeleton labelWidth={38} className="basis-60" />
              <FieldSkeleton labelWidth={50} style={{ flexBasis: COLOR_FIELD_WIDTH }} />
            </div>
          </div>
        ))}
      </div>

      <div className="col-span-5 flex justify-center">
        <div className="skeleton-block w-full" style={{ maxWidth: 220, aspectRatio: '220 / 327' }} />
      </div>
    </div>

    <div className="mb-2 flex w-1/2 justify-start pr-6">
      <div className="skeleton-block mr-4 h-9 w-1/2" />
      <div className="skeleton-block h-9 w-1/2" />
    </div>
  </div>
);

interface FieldSkeletonProps {
  /** Ширина подписи поля: «Узор» — 38px, «Цвет 1» — 50px. */
  labelWidth: number;
  className?: string;
  style?: React.CSSProperties;
}

/** Поле `ud-form`: подпись 21px, отступ `mb-2`, контрол высотой 36px. */
const FieldSkeleton: React.FC<FieldSkeletonProps> = ({ labelWidth, className, style }) => (
  <div className={classNames('flex shrink-0 grow-0 flex-col', className)} style={style}>
    {/* 21px — фактическая высота `UDFormLabel`, из неё складывается высота поля 65px. */}
    <div className="skeleton-block mb-2" style={{ width: labelWidth, height: 21 }} />
    <div className="skeleton-block h-9 w-full" />
  </div>
);

export default KitEditorSkeleton;
